import { createSelector } from 'reselect';
import { values, has, mapKeys, uniq, sortBy } from 'lodash';
import { ZERO_ADDRESS } from '@blockcatio/tabby-library/lib/constants';

import { getPayments } from './payments';

const getMergedTokens = storeState =>
  mapKeys(
    {
      ...storeState.token.defaultTokenList,
      ...storeState.token.localTokenList,
    },
    (value, key) => key.toLowerCase(),
  );

export const getTokensArray = storeState => values(getMergedTokens(storeState));

export const getTokenListByName = createSelector([getTokensArray], tokens =>
  sortBy(tokens.filter(token => token.name), ['name']));

/**
 * Generate a list of token addresses in payments that aren't in the token lists.
 *
 * @param {Object} storeState
 */
export const tokensWithoutData = (storeState) => {
  const tokens = getMergedTokens(storeState);
  return uniq(getPayments(storeState)
    .filter(p =>
      p.tokenAddress &&
          p.tokenAddress !== ZERO_ADDRESS &&
          !has(tokens, p.tokenAddress.toLowerCase()))
    .map(p => p.tokenAddress.toLowerCase()));
};

export const getTokenAddress = ({ token: { address } }) => address;



// WEBPACK FOOTER //
// ./src/selectors/token.js